<template>
  <RouterLink
    :to="'/' + service"
    class="group flex items-center rounded-md px-2 py-2 text-base font-medium leading-6 text-secondary-600 transition duration-150 ease-in-out hover:bg-secondary-50 hover:text-secondary-900 focus:bg-secondary-100 focus:text-secondary-900 focus:outline-none"
    :class="{
      'bg-secondary-100 text-secondary-900 focus:bg-secondary-200': shaded,
    }"
  >
    <MenuIcons
      :service="service"
      class="mr-3 text-secondary-500 hover:text-secondary-800"
    />
    {{ label }}
    <span
      v-if="label == 'Messages' && unreadMessageCount > 0"
      class="ml-auto inline-block rounded-full bg-primary-100 py-0.5 px-3 text-xs font-medium text-primary-600"
    >
      {{ unreadMessageCount }}
    </span>
  </RouterLink>
</template>
<script lang="ts">
import { computed, defineComponent } from "vue";
import MenuIcons from "@/components/menu/menu-icons.vue";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "mobile-menu-item",
  components: {
    MenuIcons,
  },
  props: {
    service: {
      type: String,
      default: undefined,
    },
    label: {
      type: String,
      default: undefined,
    },
    shaded: {
      type: Boolean,
      default: undefined,
    },
    unreadMessageCount: {
      type: Number,
      default: 0,
    },
  },

  setup(props) {
    const router = useRouter();

    const shaded = computed(() => {
      return router.currentRoute.value.path.startsWith(`/${props.service}`);
    });

    return {
      shaded,
    };
  },
});
</script>
